module.exports = "/_next/static/images/LetEngineersFocused@2x-e9acf326551fbbc306d32aa7ee55aa3d.png";